module.exports = __webpack_public_path__ + "img/fruit-blackberries-350x184.25b7f2ea.jpg";